import { OptionMap } from '../data/intakeOptions'

/** Zet een label-map uit data/intakeOptions om naar opties voor RadioGroup / CheckboxGroup */
export function toOptions(map: OptionMap) {
  return Object.entries(map).map(([value, label]) => ({ value, label }))
}
